import { gql } from '@apollo/client';
export const ASM_RESPONSIBLES_QUERY = gql`
  query automaticUserAllocationsResponsiblesByUserGroups {
    automaticUserAllocationsResponsiblesByUserGroups {
      asmResponsibles {
        personId
        lastName
        firstName
      }
    }
  }
`;

export const WORK_LOCATIONS_QUERY = gql`
  query workLocations($dealerId: Int!) {
    workLocations(dealerId: $dealerId) {
      id
      name
    }
  }
`;

export const DEALERS_QUERY = gql`
  query dealers {
    dealers {
      id
      name
    }
  }
`;
